import { render, staticRenderFns } from "./RemoveSubjects.vue?vue&type=template&id=99a9b776&scoped=true&lang=true&"
import script from "./RemoveSubjects.vue?vue&type=script&lang=js&"
export * from "./RemoveSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a9b776",
  null
  
)

export default component.exports